import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { useCallback } from 'react';
import { rootRoute } from '@/app/root-route.tsx';
import {
  type NewOrderSearch,
  newOrderSearchSchema,
  type OrdersSearch,
  ordersSearchSchema,
} from './search.ts';

const OrdersListPage = lazyRouteComponent(() => import('./OrdersListPage.tsx'), 'OrdersListPage');
const NewOrderPage = lazyRouteComponent(() => import('./NewOrderPage.tsx'), 'NewOrderPage');
const OrderDetailPage = lazyRouteComponent(
  () => import('./OrderDetailPage.tsx'),
  'OrderDetailPage',
);

export const medicalOrdersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/medical-orders',
  validateSearch: (search: Record<string, unknown>): OrdersSearch =>
    ordersSearchSchema.parse(search),
  component: function MedicalOrdersRouteComponent() {
    const search = medicalOrdersRoute.useSearch();
    const navigate = medicalOrdersRoute.useNavigate();
    const onSearchChange = useCallback(
      (patch: Partial<OrdersSearch>) =>
        navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
      [navigate],
    );
    return <OrdersListPage search={search} onSearchChange={onSearchChange} />;
  },
});

export const newMedicalOrderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/medical-orders/new',
  validateSearch: (search: Record<string, unknown>): NewOrderSearch =>
    newOrderSearchSchema.parse(search),
  component: function NewMedicalOrderRouteComponent() {
    const { policy } = newMedicalOrderRoute.useSearch();
    return <NewOrderPage initialPolicy={policy} />;
  },
});

export const medicalOrderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/medical-orders/$orderId',
  component: function MedicalOrderRouteComponent() {
    const { orderId } = medicalOrderRoute.useParams();
    return <OrderDetailPage orderId={orderId} />;
  },
});
